import { api, clearAuth, setAccessToken } from '@/lib/api';
import type { AuthResponse, LoginDto, RegisterDto, ApiUser } from '@/lib/types';

export interface UpdateUserProfileDto {
  displayName: string;
}

export async function authRegister(dto: RegisterDto): Promise<AuthResponse> {
  return api<AuthResponse>('/auth/register', {
    method: 'POST',
    body: JSON.stringify(dto),
    credentials: 'include',
    skipAuthRefresh: true,
  });
}

export async function authLogin(dto: LoginDto): Promise<AuthResponse> {
  return api<AuthResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify(dto),
    credentials: 'include',
    skipAuthRefresh: true,
  });
}


export async function authConfirmEmail(dto: { userId: string; token: string; }): Promise<{ message: string }> {
  return api<{ message: string }>('/auth/confirm-email', {
    method: 'POST',
    body: JSON.stringify(dto),
    credentials: 'include',
    skipAuthRefresh: true,
  });
}



// RENVOI DE L'E-MAIL DE CONFIRMATION
export async function authResendConfirmation(email: string): Promise<{ message: string }> {
  return api<{ message: string }>('/auth/resend-confirmation', {
    method: 'POST',
    body: JSON.stringify({
      email: email.trim().toLowerCase(),
    }),
    credentials: 'include',
    skipAuthRefresh: true,
  });
}

// Déconnecte la session côté serveur puis supprime l'access token en mémoire.
export async function authLogout(): Promise<void> {
  try {
    await api<void>('/auth/logout', {
      method: 'POST',
      credentials: 'include',
    });
  } finally {
    clearAuth();
  }
}

export async function authMe(): Promise<ApiUser> {
  return api<ApiUser>('/auth/me');
}

// Normalise la réponse d'authentification sans manipuler le refresh token HttpOnly.
export function normalizeAuthResponse(res: any): { accessToken: string; user: any } {
  const accessToken = res.accessToken ?? res.token ?? '';
  const user = res.user ?? res;
  return { accessToken, user };
}

// Conserve uniquement l'access token en mémoire côté frontend.
export function storeTokens(tokens: { accessToken: string }) {
  setAccessToken(tokens.accessToken);
}





// MOT DE PASSE OUBLIÉ
export async function authForgotPassword(
  email: string
): Promise<{ message: string }> {
  return api<{ message: string }>('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({
      email: email.trim().toLowerCase(),
    }),
    credentials: 'include',
    skipAuthRefresh: true,
  });
}



// RÉINITIALISATION DU MOT DE PASSE
export async function authResetPassword(dto: {
  email: string;
  token: string;
  newPassword: string;
}): Promise<{ message: string }> {
  return api<{ message: string }>('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify(dto),
    credentials: 'include',
    skipAuthRefresh: true,
  });
}